var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canShowMobileOrderDetails)?_c('order-details-top',{attrs:{"transaction":_vm.transaction,"visibility":_vm.visibilityOptions,"show-button":true}}):_vm._e(),_c('main',[(_vm.isLoading)?_c('payment-loading'):_c('div',[(_vm.isErrorDataSet)?_c('error-data'):_c('div',[_c('visa-mobile-data')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }